import type { RealtimeChannel } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

let channelCounter = 0;

export const createRealtimeChannelName = (baseName: string) => {
  channelCounter += 1;
  const safeBaseName = baseName.replace(/[^a-zA-Z0-9_-]/g, '-').slice(0, 64);
  const suffix = typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID().slice(0, 8)
    : `${Date.now().toString(36)}-${channelCounter}`;

  return `${safeBaseName}-${channelCounter}-${suffix}`;
};

export const removeRealtimeChannel = (channel: RealtimeChannel | null | undefined) => {
  if (!channel) return;

  void supabase.removeChannel(channel).catch((error) => {
    console.warn('Realtime cleanup failed:', error);
  });
};

export const logRealtimeIssue = (label: string, error: unknown) => {
  console.warn(`${label} realtime subscription skipped:`, error);
};